import React from "react";
import { Lock, Eye, Bell, XCircle } from "lucide-react";
export const Privacy = () => {
  const privacyPoints = [{
    icon: <Lock className="h-6 w-6" data-id="element-91" />,
    title: "Data Encryption",
    description: "We use encrypted channels to protect your account credentials."
  }, {
    icon: <Eye className="h-6 w-6" data-id="element-92" />,
    title: "Limited Scope",
    description: "We only post the content we've discussed and send messages for the sponsored campaign."
  }, {
    icon: <Bell className="h-6 w-6" data-id="element-93" />,
    title: "Transparency",
    description: "You'll have full visibility into the posts and messages we send on your behalf."
  }, {
    icon: <XCircle className="h-6 w-6" data-id="element-94" />,
    title: "Cancel Anytime",
    description: "If you decide this isn't for you, simply revoke access and your monthly commitments end."
  }];
  return <section className="w-full bg-gray-50 py-16" data-id="element-95">
      <div className="max-w-4xl mx-auto px-4" data-id="element-96">
        <h2 className="text-3xl font-bold text-center mb-4" data-id="element-97">
          Your Privacy Is Our Priority
        </h2>
        <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-98">
          We understand that your LinkedIn profile is personal and professional.
          Our system never accesses your private messages without permission,
          and we never make changes to your profile details or settings without
          your explicit consent.
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-99">
          {privacyPoints.map((point, index) => <div key={index} className="flex items-start space-x-4 bg-white p-6 rounded-lg shadow-sm" data-id="element-100">
              <div className="text-emerald-600" data-id="element-101">{point.icon}</div>
              <div data-id="element-102">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-103">
                  {point.title}
                </h3>
                <p className="text-gray-600" data-id="element-104">{point.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};